export default "/_next/static/images/VeganLogo.png";